module.exports = ___sgwt_webpack_dll___react_v16;